import axios from 'axios';

// Axios instance SANS authentification pour les requêtes publiques
const publicInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export default publicInstance;
